module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-8"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('searchClients', {
    on: {
      "selected": _vm.selectClient
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.matter_desc),
      expression: "invoice.matter_desc"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.invoice, "matter_desc", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.visatypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.user && _vm.user.stripe_id) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column col-7 col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instant_payment),
      expression: "instant_payment"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.instant_payment) ? _vm._i(_vm.instant_payment, null) > -1 : (_vm.instant_payment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.instant_payment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.instant_payment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.instant_payment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.instant_payment = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.no_gst),
      expression: "no_gst"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.no_gst) ? _vm._i(_vm.no_gst, null) > -1 : (_vm.no_gst)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.no_gst,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.no_gst = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.no_gst = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.no_gst = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.description),
      expression: "newItem.description"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newItem, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selItem]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.descriptions), function(d) {
    return _c('option', {
      domProps: {
        "value": d
      }
    }, [_vm._v(_vm._s(d))])
  })], 2)]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newItem.cost),
      expression: "newItem.cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.newItem.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])])]), _vm._v(" "), _vm._l((_vm.invoice.items), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.delItem(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])])
  }), _vm._v(" "), (_vm.totals[0]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("GST")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[0])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[1]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Surcharge")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[1])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[2]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[2])))])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan),
      expression: "plan"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan) ? _vm._i(_vm.plan, null) > -1 : (_vm.plan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plan = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Initial payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_initial),
      expression: "plan_initial",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_initial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_initial = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Monthly payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_monthly),
      expression: "plan_monthly",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_monthly)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_monthly = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(!_vm.success) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Success")]), _vm._v(" "), (_vm.errormsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errormsg))]) : _vm._e(), _vm._v(" "), (_vm.newInvoice) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.othermodal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Item description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDesc),
      expression: "newDesc"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.newDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.surcharge),
      expression: "newItem.surcharge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newItem.surcharge) ? _vm._i(_vm.newItem.surcharge, null) > -1 : (_vm.newItem.surcharge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newItem.surcharge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newItem, "surcharge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newItem, "surcharge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newItem, "surcharge", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Surcharge\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addDesc($event)
      }
    }
  }, [_vm._v("Done")])])])]), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "invoice": _vm.newInvoice
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      },
      "done": _vm.reset
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Matter description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-3 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Instant payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("No GST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Payment plan")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44f19d26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/makeInvoice.vue
// module id = 494
// module chunks = 1